import { render, staticRenderFns } from "./CheckoutChoosePlanStep.vue?vue&type=template&id=db5c5bc8"
import script from "./CheckoutChoosePlanStep.vue?vue&type=script&lang=js"
export * from "./CheckoutChoosePlanStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports